/**
 * Amplify Auth bootstrap for the worker PWA. Same Cognito user pool as admin,
 * but a different app client (longer refresh, no MFA enforced).
 */
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { defaultStorage } from 'aws-amplify/utils';

interface AmplifyEnv {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  apiUrl: string;
}

function readEnv(): AmplifyEnv {
  const env = import.meta.env;
  const required = {
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    userPoolClientId: env.VITE_COGNITO_USER_POOL_CLIENT_ID,
    apiUrl: env.VITE_API_URL,
  };
  for (const [k, v] of Object.entries(required)) {
    if (!v) throw new Error(`Missing env var for VITE_${k.replace(/[A-Z]/g, (c) => `_${c}`).toUpperCase()}`);
  }
  return required as AmplifyEnv;
}

export const ENV = readEnv();

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: ENV.userPoolId,
      userPoolClientId: ENV.userPoolClientId,
      signUpVerificationMethod: 'code',
      loginWith: { email: true },
    },
  },
});

// Persist tokens in localStorage so the PWA stays signed in across reloads + offline.
cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);
